<template>
  <div class="home">
    <PasswordLock v-if="!globalState.authenticated" />
    <QueryForm v-else />
  </div>
</template>

<script>
import PasswordLock from '@/components/PasswordLock.vue';
import QueryForm from '@/components/QueryForm.vue';
import { inject, watchEffect } from 'vue';

export default {
  name: 'HomePage',
  components: {
    QueryForm,
    PasswordLock
  },
  setup() {
    const globalState = inject('globalState');

    watchEffect(() => {
      console.log('Global state updated:', globalState.authenticated);
    });

    return {
      globalState
    };
  }
};
</script>

<style scoped>
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f9f9f9;
}
</style>
